<div class="select-voucher-container">
  <app-mobile-header [title]="'label.vouchers'" [manualBackEvent]="true"
    (onManualBackEvent)="onBack()"></app-mobile-header>

  <form (ngSubmit)="onSearch()" [formGroup]="searchFgroup" (keyup.enter)="onSearch();" class="search-bar">
    <div class="input-outline selectVoucher-searchBar">
      <i class="icon-voucher-coupon"></i>
      <span class="p-float-label">
        <input id="searchCode" type="text" class="inputFielsTruncateText" pInputText formControlName="searchCode"
          #searchCode appInputTrim>
        <label for="searchCode">{{'label.search.enter.voucher.code' | translate}}</label>
      </span>
      <i class="icon-times" *ngIf="searchCode.value && searchCode.value.length > 0" (click)="resetSearch()"></i>
    </div>
  </form>

  <div class="selectVoucher-content" *ngIf="applicableVouchers && applicableVouchers.length > 0"
    [hidden]="showNoVouchers">
    <div class="selectVoucher-voucherListing" id="card-group-{{ applicableVoucher.vchCatgId }}"
      *ngFor="let applicableVoucher of applicableVouchers">
      <h1 class="title">{{ applicableVoucher.vchCatgCode | translate | titlecase }}
        <span class="desc" *ngIf="applicableVoucher.multiFlag === 0">({{'desc.select.one.voucher.to.apply' |
          translate}})</span>
        <span class="desc" *ngIf="applicableVoucher.multiFlag > 0">({{'desc.select.any.voucher.to.apply' |
          translate}})</span>
      </h1>

      <app-reward-card [myReward]="reward" [selectedReward]="selectedVouchers" [channelId]="channelId"
        [customCardType]="applicableVoucher.multiFlag > 0? cardTypes.multiSelect: cardTypes.singleSelect"
        [orderData]="orderData" *ngFor="let reward of applicableVoucher.voucherList; let i = index;"
        [hidden]="searchVouchers && searchVouchers.length > 0"></app-reward-card>

      <div *ngIf="searchVouchers && searchVouchers.length > 0">
        <app-reward-card [exploreReward]="searchVoucher" [isLoggedIn]="isLoggedIn" [channelId]="channelId"
          [storeId]="storeId" *ngFor="let searchVoucher of searchVouchers"></app-reward-card>
      </div>
    </div>
  </div>

  <ng-template [ngIf]="showNoVouchers">
    <div class="no-voucher">
      <img src="assets/generalImage/reward_voucher.svg">
      <h1 class="title">{{ 'desc.no.voucher.found' | translate }}</h1>
    </div>
  </ng-template>


  <app-bottom-action-footer [buttonName]="'button.apply'" (click)="onApply()"
    *ngIf="applicableVouchers && applicableVouchers.length > 0"></app-bottom-action-footer>
</div>